module.exports = __webpack_public_path__ + "static/media/Emil.3631065d.jpg";